<template>
	<div id="usre-baseinfor" class="oh" v-title :data-title="title">
		<!-- 政府端 -->
		<leftnav class="fl" mkcode="E" itemcode="E-WDGXW"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader :show-video="true" :video-type="5"></govheader>
			<div class="index_left_centerpage">  
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="我的关系网"></freeUserTips>
				</div>
			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'userRelational',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	  data(){return{
				userdata:{}, 
				title:'我的关系网', 
			relationlist:[],
			}},
		 created() { 
		 },
			mounted() {
			},
			methods:{  
				getlist(){
					var _this=this;
					this.$axios.get(this.$api.cyl.enterpriseRelation.list()+'?page=1', {headers: {AuthToken: this.userdata.token}
					}).then(function(res) {
						if(res.data.success){
						console.log('关系列表', res.data.list); 
						_this.relationlist=res.data.list;
							_this.bus.$emit('loading', false);
						} else {
							
						}
					}).catch(function(error) {console.log(error)});
				},
				
				
				
			}
	}  
</script>

<style>
	
</style>
